import { EzEnumeration2 } from '/ezlibrary/enums/EzEnumeration2.js';

import {
    EzString
} from '/ezlibrary/helpers/EzHelpers.js';


/**
 * @class
 * @extends {EzEnumeration2}
 * Enumeration representing the ezApi registration state of an ezClocker class.
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Import into non-enumeration classes with:
 *     import {
 *         // ... other enumeration classes ...
 *         EzRegistrationState
 *     } from '/ezlibrary/enums/EzEnumerations.js';
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Import into other enumeration classes with:
 *     import { EzRegistrationState } from '/ezlibrary/enums/EzRegistrationState.js';
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Static access only with:
 *     EzRegistrationState.{property or method}
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */
export class EzRegistrationState extends EzEnumeration2 {
    /**
     * @static
     * @public
     * @function
     * @description
     * Determiens if the provided ezRegistrationState is EzRegistrationState.PENDING
     * @returns {boolean}
     */
    static ezIsStatePendingState(ezRegistrationState) {
        return EzString.hasText(ezRegistrationState) && EzRegistrationState.PENDING === ezRegistrationState;
    }

    /**
     * @static
     * @public
     * @function
     * @description
     * Determiens if the provided ezRegistrationState is null/empty string, EzRegistrationState.UNKNOWN,
     * or EzRegistrationState.NOT_REGISTERED
     * @returns {boolean}
     */
    static ezIsNotRegisteredState(ezRegistrationState) {
        return EzString.hasText(ezRegistrationState) &&
            (EzRegistrationState.NOT_REGISTERED === ezRegistrationState || EzRegistrationState.UNKNOWN === ezRegistrationState);
    }

    /**
     * @static
     * @public
     * @function
     * @description
     * Determiens if the provided ezRegistrationState is EzRegistrationState.REGISTERED
     * @returns {boolean}
     */
    static ezIsRegisteredState(ezRegistrationState) {
        return EzString.hasText(ezRegistrationState) && EzRegistrationState.REGISTERED === ezRegistrationState.toUpperCase();
    }

    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // Enumeration Class Initialization Section
    // !! DO NOT PLACE ANY non-initialization fields, getter/setter methods, static methods, or class methods beyond this section !!
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

    /**
     * @private
     * @property {EzRegistrationState} ezEnumerationSingleton
     * @description
     * Stores the singleton instance for the enumeration class
     */
    static #ezEnumerationSingleton = null;

    /**
     * @static
     * @private
     * @function
     * @description
     * Builds the enumeration properties and values for EzClockerAccountType
     * @returns {EzRegistrationState}
     */
    static #ezInit() {
        EzRegistrationState.#ezEnumerationSingleton.ezBuildEnumProp(
            // Enumeration Property Name
            'UNKNOWN',
            // Enumeration Property Value
            null,
            // Enumeration Data Value
            {
                value: null,
                display: 'Not Registered: Registration of the singleton instance with EzApi has not started and is not complete.'
            });

        EzRegistrationState.#ezEnumerationSingleton.ezBuildEnumProp(
            // Enumeration Property Name
            'NOT_REGISTERED',
            // Enumeration Property Value
            'NOT_REGISTERED',
            // Enumeration Data Value
            {
                value: 'NOT_REGISTERED',
                display: 'Not Registered: Registration of the singleton instance with EzApi has not started or completed.'
            });

        EzRegistrationState.#ezEnumerationSingleton.ezBuildEnumProp(
            // Enumeration Property Name
            'PENDING',
            // Enumeration Property Value
            'PENDING',
            // Enumeration Data Value
            {
                value: 'PENDING',
                display: 'Pending: The class is currently attempting to be has successfully registered its singleton instance with EzApi..'
            });

        EzRegistrationState.#ezEnumerationSingleton.ezBuildEnumProp(
            // Enumeration Property Name
            'REGISTERED',
            // Enumeration Property Value
            'REGISTERED',
            // Enumeration Data Value
            {
                value: 'REGISTERED',
                display: 'Registered: The class has successfully registered its singleton instance with EzApi.'
            });

        EzRegistrationState.#ezEnumerationSingleton.ezBuildEnumProp(
            // Enumeration Property Name
            'UNKNOWN',
            // Enumeration Property Value
            null,
            // Enumeration Data Value
            {
                value: null,
                display: 'UNKNOWN'
            });

        globalThis.EzRegistrationState = EzRegistrationState;

        return EzRegistrationState;
    }

    /**
     * @static
     * Static Initialization
     */
    static {
        if (null == EzRegistrationState.#ezEnumerationSingleton) {
            EzRegistrationState.#ezEnumerationSingleton = new EzRegistrationState();

            EzRegistrationState.#ezInit();
        }
    }

    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // !! DO NOT PLACE ANY non-initialization fields, getter/setter methods, static methods, or class methods beyond above section !!
    // !! PLEASE, NO CLASS CODE AFTER THIS SECTION !!
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
}
